export class TEMPLATES {
  static readonly menu = 1;
};

export class VERSIONS {
  static readonly latest = 0;
}

export class TEMPLATE_NAMES {
  static readonly homepage = 'homepage';
}
